var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"error-401 text-large"},[_c('div',{staticClass:"error-401__message"},[_vm._v("セッションがタイムアウトしました。")]),_c('a',{attrs:{"href":_vm.topPage}},[_vm._v("戻る")])])
}
var staticRenderFns = []

export { render, staticRenderFns }